<div class="row">
    <div class="col-md-12 hero-section">
        <app-builder-io-renderer *ngIf="loaded; else loadingTemplate" [apiKey]="apiKey" [entry]="entry">
            <div class="container">Failed to load hero</div>
        </app-builder-io-renderer>
        <ng-template #loadingTemplate></ng-template>
    </div>
</div>
